<div class="date-picker-container">
    <mat-form-field appearance="outline" class="program-dropdown">
        <mat-label>Programs</mat-label>
        <mat-select [(ngModel)]="selectedProgram">
        <mat-option *ngFor="let program of programs" [value]="program.ID">
            {{ program.VALUE }}
        </mat-option>
        </mat-select>
    </mat-form-field>  
    <mat-form-field appearance="outline" class="date-picker">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="date-picker">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
    </mat-form-field>
    <button mat-flat-button color="primary" class="apply-btn" (click)="onApply()">APPLY</button>
</div>